module.exports = "/_next/static/images/bbe0afaa87a779985030bf431982cba2.png";